import { AxiosResponse } from 'axios';
import { dataStores } from 'core-roblox-utilities';
import { TAssetType, TCarouselItem, TGetUniverseAssetIdsResponse } from '../types/carouselTypes';

const { gamesDataStore } = dataStores;

const getUniverseAssetIds = async (universeId: string): Promise<TCarouselItem[]> => {
  const {
    data: { data = [] }
  } = ((await gamesDataStore.getUniverseMedia(universeId)) as unknown) as AxiosResponse<{
    data?: TGetUniverseAssetIdsResponse[];
  }>;
  return data
    .filter(asset => asset.approved)
    .map<TCarouselItem>(asset => {
      switch (asset.assetType) {
        case TAssetType.Image:
          return { type: asset.assetType, assetId: asset.imageId };
        case TAssetType.YouTubeVideo:
          return { type: asset.assetType, assetId: asset.videoHash };
        default:
          return { type: TAssetType.Unknown, assetId: 0 };
      }
    })
    .filter(asset => asset.type !== TAssetType.Unknown);
};

export default {
  getUniverseAssetIds
};
